import React from 'react';
import PropType from 'prop-types';
import styled from 'styled-components';

const LoginContainer = styled.nav`
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    color: #2d3436;
    border-radius: 10px;
    margin-top: 10vh;
`

const Title = styled.h1`
    font-size: 125px;
    font-weight: bold;
    margin: 0;
    text-align: center;
`

const Quote = styled.p`
    font-size: 16px;
    font-style: italic;
    font-weight: 100;
    margin-bottom: 30px;
`

const SignInButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 30px;
    background: #fff;
    color: #636e72;
    border: 1px solid #636e72;
    border-radius: 5px;

    :hover {
        cursor: pointer;
    }

    .google-logo {
        display: inline-block;
        height: 20px;
        width: 20px;
        margin-right: 10px;
    }

    span {
        font-size: 16px;
        font-weight: bold;
    }
`

const Login = (props) => (
    <LoginContainer className="login">
        <Title>Flow Timer</Title>
        <Quote>&ldquo;Time is what we want most, but what we use worst.&rdquo; - William Penn</Quote>
        <SignInButton
            className="sign-in"
            onClick={() => props.authenticate('Google')}>
            <img className="google-logo" src="data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgdmlld0JveD0iMCAwIDQ4IDQ4Ij48Zz48cGF0aCBmaWxsPSIjRUE0MzM1IiBkPSJNMjQgOS41YzMuNTQgMCA2LjcxIDEuMjIgOS4yMSAzLjZsNi44NS02Ljg1QzM1LjkgMi4zOCAzMC40NyAwIDI0IDAgMTQuNjIgMCA2LjUxIDUuMzggMi41NiAxMy4yMmw3Ljk4IDYuMTlDMTIuNDMgMTMuNzIgMTcuNzQgOS41IDI0IDkuNXoiPjwvcGF0aD48cGF0aCBmaWxsPSIjNDI4NUY0IiBkPSJNNDYuOTggMjQuNTVjMC0xLjU3LS4xNS0zLjA5LS4zOC00LjU1SDI0djkuMDJoMTIuOTRjLS41OCAyLjk2LTIuMjYgNS40OC00Ljc4IDcuMThsNy43MyA2YzQuNTEtNC4xOCA3LjA5LTEwLjM2IDcuMDktMTcuNjV6Ij48L3BhdGg+PHBhdGggZmlsbD0iI0ZCQkMwNSIgZD0iTTEwLjUzIDI4LjU5Yy0uNDgtMS40NS0uNzYtMi45OS0uNzYtNC41OXMuMjctMy4xNC43Ni00LjU5bC03Ljk4LTYuMTlDLjkyIDE2LjQ2IDAgMjAuMTIgMCAyNGMwIDMuODguOTIgNy41NCAyLjU2IDEwLjc4bDcuOTctNi4xOXoiPjwvcGF0aD48cGF0aCBmaWxsPSIjMzRBODUzIiBkPSJNMjQgNDhjNi40OCAwIDExLjkzLTIuMTMgMTUuODktNS44MWwtNy43My02Yy0yLjE1IDEuNDUtNC45MiAyLjMtOC4xNiAyLjMtNi4yNiAwLTExLjU3LTQuMjItMTMuNDctOS45MWwtNy45OCA2LjE5QzYuNTEgNDIuNjIgMTQuNjIgNDggMjQgNDh6Ij48L3BhdGg+PHBhdGggZmlsbD0ibm9uZSIgZD0iTTAgMGg0OHY0OEgweiI+PC9wYXRoPjwvZz48L3N2Zz4K" alt="Google"/>
            <span>Sign in with Google</span>
        </SignInButton>
    </LoginContainer>
)

Login.propTypes = {
    authenticate: PropType.func.isRequired
}

export default Login;


// WEBPACK FOOTER //
// ./src/Login.js